import { CheckCircle2 } from "lucide-react";

const VerticalSections = ({ whyItems, benefitsTitle, benefits, steps }) => {
  return (
    <>
      {/* Pourquoi passer par LLDLS */}
      <section className="py-16 md:py-24 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            <div>
              <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6">
                Pourquoi passer par <span className="text-amber-500">LLDLS</span> ?
              </h2>
              <ul className="space-y-4">
                {whyItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3" data-testid={`why-item-${index}`}>
                    <CheckCircle2 className="w-6 h-6 text-amber-500 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-300 text-base sm:text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-slate-800 rounded-2xl p-6 sm:p-8">
              <h3 className="font-heading text-xl sm:text-2xl font-semibold text-white mb-6">
                {benefitsTitle}
              </h3>
              <ul className="space-y-4">
                {benefits.map((item, index) => (
                  <li key={index} className="flex items-start gap-3" data-testid={`benefit-item-${index}`}>
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-300 text-base sm:text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Comment ça se passe */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 text-center mb-12">
            Comment ça se passe ?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {steps.map((step, index) => (
              <div
                key={index}
                className="relative bg-slate-50 rounded-2xl p-6 sm:p-8 border border-slate-100"
                data-testid={`step-card-${index}`}
              >
                <div className="w-12 h-12 bg-amber-500 text-white rounded-full flex items-center justify-center font-heading font-bold text-xl mb-5">
                  {index + 1}
                </div>
                <p className="text-slate-700 text-base sm:text-lg font-medium">{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default VerticalSections;
